module.exports = __webpack_public_path__ + "static/img/img_qukuailian_youdian7.2de4cf96.png";